import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import authSlice from './slices/authSlice'
import dashboardSlice from './slices/dashboardSlice'
import subscriptionSlice from './slices/subscriptionSlice'
import userSlice from './slices/userSlice'
import gardenSlice from './slices/gardenSlice'
import deliverySlice from './slices/deliverySlice'
import systemSlice from './slices/systemSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    dashboard: dashboardSlice,
    subscriptions: subscriptionSlice,
    users: userSlice,
    gardens: gardenSlice,
    delivery: deliverySlice,
    system: systemSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector



